var subDomain = "api";
if (window.location.host != "www.startfreept.com" && window.location.host != "startfreept.com") {
  subDomain = "uatapi";
}

export const URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/analyze";
export const URLPlan = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/sendPlan";
export const BETA_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/betaAccess";

export const LOGO = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/startfreept_logo.svg";
export const LOGO_PLACEHOLDER = "https://placehold.co/128x32/e2e8f0/475569?text=Logo";
export const HOME_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/WelcomeToStartFreePTv2.0.mp4";
export const HOME_VIDEO_2 = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/HeroVideo-v13.0.mp4";
export const SKELETON = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/VH-Bodyoutline.png";
export const SKELETON_PLACEHOLDER = "https://placehold.co/250x500/e2e8f0/475569?text=Body+Outline";

// Modified for Floor & Attributes on Aug 10th 2025

// First videos
export const SeatedTrunkRotation = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationv1.0.mp4";
export const SupineDoubleKneeToChest = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SupineDoubleKneeToChestROMv1.0.mp4";
export const StandingSideBend = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SideToSideBendv1.0.mp4";
export const StandingLumbarExtension = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROMv1.0.mp4";
export const SeatedSingleKneeToChest = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedSingleKneeToChestv1.0.mp4";
export const ToeTouch = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchv1.0.mp4";
export const PronePressUp = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PronePressUpROMv1.0.mp4";

// Negative videos
export const SeatedTrunkRotationNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationvNegative1.0.mp4";
export const PronePressUpNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PronePressUpROMNegativev1.0.mp4";
export const ToeTouchNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4";
export const StandingLumbarExtensionNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROM-Negativev1.0.mp4";

// export const ZONES = [
//   {
//     id: "LOWER_BACK_LEFT",
//     label: "L Back",
//     name: "Left Lower Back",
//     style: { width: "46px", height: "42px", top: "191px", left: "75px" },
//   },
//   {
//     id: "LOWER_BACK_RIGHT",
//     label: "R Back",
//     name: "Right Lower Back",
//     style: { width: "46px", height: "42px", top: "191px", left: "129px" },
//   },
//   {
//     id: "BUTTOCK_LEFT",
//     label: "L Buttock",
//     name: "Left Buttock",
//     style: { width: "50px", height: "42px", top: "233px", left: "73px" },
//   },
//   {
//     id: "BUTTOCK_RIGHT",
//     label: "R Buttock",
//     name: "Right Buttock",
//     style: { width: "50px", height: "42px", top: "233px", left: "127px" },
//   },
//   {
//     id: "THIGH_LEFT",
//     label: "L Thigh",
//     name: "Left Thigh",
//     style: { width: "50px", height: "75px", top: "275px", left: "73px" },
//   },
//   {
//     id: "THIGH_RIGHT",
//     label: "R Thigh",
//     name: "Right Thigh",
//     style: { width: "50px", height: "75px", top: "275px", left: "127px" },
//   },
//   {
//     id: "LEG_LEFT",
//     label: "L Leg",
//     name: "Left Lower Leg",
//     style: { width: "42px", height: "83px", top: "329px", left: "79px" },
//   },
//   {
//     id: "LEG_RIGHT",
//     label: "R Leg",
//     name: "Right Lower Leg",
//     style: { width: "42px", height: "83px", top: "329px", left: "129px" },
//   },
// ];

export const ZONES = [
  { id: "LOWER_BACK_LEFT", label: "L Back", name: "Left Lower Back", style: { width: "46px", height: "42px", top: "191px", left: "75px" } },
  { id: "LOWER_BACK_RIGHT", label: "R Back", name: "Right Lower Back", style: { width: "46px", height: "42px", top: "191px", left: "129px" } },
  { id: "BUTTOCK_LEFT", label: "L Buttock", name: "Left Buttock", style: { width: "50px", height: "42px", top: "233px", left: "73px" } },
  { id: "BUTTOCK_RIGHT", label: "R Buttock", name: "Right Buttock", style: { width: "50px", height: "42px", top: "233px", left: "127px" } },
  { id: "THIGH_LEFT", label: "L Thigh", name: "Left Thigh", style: { width: "50px", height: "75px", top: "275px", left: "73px" } },
  { id: "THIGH_RIGHT", label: "R Thigh", name: "Right Thigh", style: { width: "50px", height: "75px", top: "275px", left: "127px" } },
  { id: "LEG_LEFT", label: "L Leg", name: "Left Lower Leg", style: { width: "42px", height: "83px", top: "329px", left: "79px" } },
  { id: "LEG_RIGHT", label: "R Leg", name: "Right Lower Leg", style: { width: "42px", height: "83px", top: "329px", left: "129px" } },
];

export const CLINICAL_PATHS = {
  LBP: {
    name: "Low Back",
    zones: ZONES,
  },
  HIP: {
    name: "Hip",
    zones: [
      { id: "BUTTOCK_LEFT_HIP", label: "L Buttock", name: "Left Buttock", style: { width: "50px", height: "42px", top: "233px", left: "73px" } },
      { id: "BUTTOCK_RIGHT_HIP", label: "R Buttock", name: "Right Buttock", style: { width: "50px", height: "42px", top: "233px", left: "127px" } },
      { id: "THIGH_LEFT_HIP", label: "L Thigh", name: "Left Thigh", style: { width: "50px", height: "75px", top: "275px", left: "73px" } },
      { id: "THIGH_RIGHT_HIP", label: "R Thigh", name: "Right Thigh", style: { width: "50px", height: "75px", top: "275px", left: "127px" } },
      { id: "HIP_ANTERIOR_LEFT", label: "L Ant. Hip/Groin", name: "Left Anterior Hip/Groin", style: { width: "40px", height: "40px", top: "240px", left: "80px" } },
      { id: "HIP_ANTERIOR_RIGHT", label: "R Ant. Hip/Groin", name: "Right Anterior Hip/Groin", style: { width: "40px", height: "40px", top: "240px", left: "130px" } },
      { id: "HIP_LATERAL_LEFT", label: "L Lat. Hip", name: "Left Lateral Hip", style: { width: "30px", height: "60px", top: "250px", left: "60px" } },
      { id: "HIP_LATERAL_RIGHT", label: "R Lat. Hip", name: "Right Lateral Hip", style: { width: "30px", height: "60px", top: "250px", left: "160px" } },
    ],
  },
  THIGH: {
    name: "Thigh",
    zones: [
      { id: "THIGH_ANTERIOR", name: "Anterior Thigh", style: { width: "50px", height: "75px", top: "275px", left: "73px" } },
      { id: "THIGH_POSTERIOR", name: "Posterior Thigh", style: { width: "50px", height: "75px", top: "275px", left: "127px" } },
    ],
  },
  KNEE: {
    name: "Knee",
    zones: [
      { id: "KNEE_ANTERIOR", name: "Anterior Knee", style: { width: "40px", height: "40px", top: "350px", left: "80px" } },
      { id: "KNEE_MEDIAL", name: "Medial Knee", style: { width: "30px", height: "40px", top: "350px", left: "100px" } },
      { id: "KNEE_LATERAL", name: "Lateral Knee", style: { width: "30px", height: "40px", top: "350px", left: "50px" } },
      { id: "KNEE_POSTERIOR", name: "Posterior Knee", style: { width: "40px", height: "40px", top: "350px", left: "130px" } },
    ],
  },
  SHOULDER: {
    name: "Shoulder",
    zones: [
      { id: "SHOULDER_ANTERIOR", name: "Anterior Shoulder", style: { width: "40px", height: "40px", top: "120px", left: "90px" } },
      { id: "SHOULDER_LATERAL", name: "Lateral Shoulder", style: { width: "40px", height: "50px", top: "120px", left: "60px" } },
      { id: "SHOULDER_POSTERIOR", name: "Posterior Shoulder", style: { width: "40px", height: "40px", top: "120px", left: "140px" } },
      { id: "SHOULDER_SUPERIOR", name: "Superior Shoulder", style: { width: "50px", height: "30px", top: "100px", left: "100px" } },
    ],
  },
};

export const compassLevelNames = {
  1: "Foundational Awareness",
  2: "Foundational Mobility",
  3: "Core Activation & Mobility",
  4: "Introductory Strengthening",
  5: "Progressive Strengthening",
};
export const CPG_OPTIONS = [
  {
    id: "cpg-radiating",
    label: "A sharp, shooting pain that feels like a narrow line.",
    value: "LBP with Radiating Pain (Radiculopathy)",
  },
  {
    id: "cpg-referred",
    label: "A more spread out, dull, or deep ache.",
    value: "LBP with Related (Referred) Lower Extremity Pain",
  },
  {
    id: "cpg-unsure-leg",
    label: "Both / Not Sure",
    value: "LBP with Related (Referred) Lower Extremity Pain",
  },
];

export const BACK_CPG_OPTIONS = [
  {
    id: "cpg-mobility",
    label: "A feeling of deep, stiff aching and restricted movement.",
    value: "LBP with Mobility Deficits",
  },
  {
    id: "cpg-coordination",
    label: 'A feeling of instability, weakness, or the back "giving out".',
    value: "LBP with Movement Coordination Impairments",
  },
  {
    id: "cpg-unsure-back",
    label: "Both / Not Sure",
    value: "LBP with Movement Coordination Impairments",
  },
];

export const testMap = {
  FLEXION_INTOLERANT: {
    name: "Standing Lumbar Extension",
    video: StandingLumbarExtension,
  },
  EXTENSION_INTOLERANT: {
    name: "Supine Double Knee to Chest",
    video: SupineDoubleKneeToChest,
  },
  NEUTRAL_SENSITIVE: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotation,
  },
  LIMITED_LUMBAR_MOBILITY: {
    name: "Standing Side Bend",
    video: StandingSideBend,
  },
  ROTATIONAL_INTOLERANT: { name: "Standing Lumbar Extension", video: StandingLumbarExtension },
  SUBSTITUTE_TEST_1: {
    name: "Seated Single Knee to Chest",
    video: SeatedSingleKneeToChest,
  },
};

export const negativeTestMap = {
  FLEXION_INTOLERANT: {
    name: "Toe Touch",
    video: ToeTouchNeg,
  },
  EXTENSION_INTOLERANT: {
    name: "Prone Press Up",
    // video: StandingLumbarExtensionNeg,
    video: PronePressUpNeg,
  },
  LIMITED_LUMBAR_MOBILITY: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotationNeg,
  },
  ROTATIONAL_INTOLERANT: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotation
  },
  // Modified for Floor & Attributes on Aug 10th 2025
  SUBSTITUTE_TEST_2: {
    name: "Standing Lumbar Extension",
    video: StandingLumbarExtensionNeg, // Using its own video
  },
};

export const testSpecificIntroVideos = {
  "Standing Lumbar Extension": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-StandingLumbarExtension-v1.0.mp4",
  "Supine Double Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SupineDoubleKneeToChest-v1.0.mp4",
  "Seated Trunk Rotation": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SeatedTrunkRotation-v1.0.mp4",
  "Standing Side Bend": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SideToSideBend-v1.0.mp4",
  "Seated Single Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SeatedSingleKneeToChest-v1.0.mp4",
  "Toe Touch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4",
};

export const DEFAULT_INTRO_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/self_media/VH-ARTargetExplanationv1.0.mp4";

export const activityLevels = [
  { id: "activity-sedentary", value: "SEDENTARY", label: "0 days", tabIndex: 5 },
  { id: "activity-light", value: "LIGHTLY_ACTIVE", label: "1-2 days", tabIndex: 6 },
  { id: "activity-active", value: "ACTIVE", label: "3-4 days", tabIndex: 7 },
  { id: "activity-very-active", value: "VERY_ACTIVE", label: "5+ days", tabIndex: 8 },
];

// export const scheduleDays = [
//   { id: "days-2-3", value: "2-3", label: "2-3" },
//   { id: "days-3-4", value: "3-4", label: "3-4" },
//   { id: "days-5-plus", value: "5+", label: "5+" },
// ];

// export const scheduleTimes = [
//   { id: "time-10-15", value: "10-15", label: "10-15 min" },
//   { id: "time-15-20", value: "15-20", label: "15-20 min" },
//   { id: "time-20-30", value: "20-30", label: "20-30 min" },
// ];

export const scheduleDaysOptions = [
  { id: "days-2", value: "2", label: "2", tabIndex: 14 },
  { id: "days-3", value: "3", label: "3", tabIndex: 15 },
  { id: "days-4", value: "4", label: "4", tabIndex: 16 },
  { id: "days-5-plus", value: "5+", label: "5+", tabIndex: 17 },
];

export const scheduleTimeOptions = [
  { id: "time-10", value: "10", label: "10 min", tabIndex: 20 },
  { id: "time-15", value: "15", label: "15 min", tabIndex: 21 },
  { id: "time-20", value: "20", label: "20 min", tabIndex: 22 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const floorOptions = [
  { id: "capability-floor-yes", value: "yes", label: "Yes, I am comfortable", tabIndex: 9 },
  { id: "capability-floor-no", value: "no", label: "No, it is too difficult right now", tabIndex: 10 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const balanceOptions = [
  { id: "balance-steady", value: "steady", label: "Steady", tabIndex: 11 },
  { id: "balance-mixed", value: "unsteady", label: "Steady & Unsteady", tabIndex: 12 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const goalOptions = [
  { id: "goal-stand-walk", value: "stand_walk", label: "Improve my ability to stand and walk" },
  { id: "goal-strength", value: "strength", label: "Increase my overall strength" },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const sessionOptions = [
  { id: "session-one", value: "one", label: "One Session", tabIndex: 18 },
  { id: "session-multiple", value: "multiple", label: "Two Sessions", tabIndex: 19 },
];

export const messaging = {
  // Sourced from the isolated prototype's data
  diagnosis: {
    LIMITED_LUMBAR_MOBILITY: {
      headline: "Your Back Pain May Be Caused by Stiffness",
      clinicalTerm: "Limited Lumbar Mobility",
      implications: "Because your lower back isn't moving as freely as it could, you might find that activities like putting on your shoes, getting out of a car, or twisting to reach for something feel stiff and difficult.",
      relief: "Gentle Movement In All Directions May Provide Relief",
    },
    NEUTRAL_SENSITIVE: {
      headline: "Your Back Seems to Want More Support",
      clinicalTerm: "Movement Coordination Impairments",
      implications: 'You might notice that your back feels weak, unstable, or like it might "give out." Changing positions frequently may be your best source of relief right now.',
      relief: "Changing Positions Frequently May Be Your Best Source Of Relief Right Now",
    },
    FLEXION_INTOLERANT: {
      headline: "Your Back Dislikes Bending Forward",
      clinicalTerm: "Flexion Intolerance",
      implications: "Activities that involve rounding your lower back, like slouching or tying your shoes, are likely to increase your discomfort. You may find that standing or gently arching your back provides relief.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
    EXTENSION_INTOLERANT: {
      headline: "Your Back Dislikes Arching or Extended Standing",
      clinicalTerm: "Extension Intolerance",
      implications: "You might find that prolonged standing or walking is uncomfortable, and that sitting or slouching provides relief.",
      relief: "You May Find That Sitting Or Slouching Provides Relief",
    },
    ROTATIONAL_INTOLERANT: {
      headline: "Your Back Dislikes Twisting",
      clinicalTerm: "Rotational Intolerance",
      implications: "You might find that movements involving twisting, turning, or reaching across your body increase your discomfort. Turning your whole body instead of just your back during these activities may help.",
      relief: "Minimizing Twisting Motions May Provide Relief",
    },
    HIGH_FUNCTIONING: {
      headline: "Your Back Is Ready to Level Up",
      clinicalTerm: "High Functioning / Low Irritability",
      implications: "You’veshown strong control and minimal symptoms during the assessment, so you are well-positioned to progress beyond basic exercises and build a stronger, more durable back.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
  },
  readinessTiers: {
    READY_TO_GO: {
      headline: "Ready to Go",
      description: "Your history and health factors show you're ready for a standard starting intensity.",
    },
    CAUTIOUS_START: {
      headline: "A Cautious Start",
      description: "We've slightly adjusted the intensity of your plan to ensure your body adapts well as you get started.",
    },
    GENTLE_APPROACH: {
      headline: "A Gentle Approach",
      description: "We've adjusted your plan to begin with a gentler intensity, giving your body extra time to respond and build momentum safely.",
    },
    STARTING_WITH_CARE: {
      headline: "Starting with Care",
      description: "To ensure the safest start, your plan begins with a very gentle intensity, focused on building a solid foundation.",
    },
  },
  planFocus: {
    FLEXION_INTOLERANT: "Reduce Sensitivity to Bending",
    EXTENSION_INTOLERANT: "Relieve Pressure from Arching",
    LIMITED_LUMBAR_MOBILITY: "Improve Flexibility",
    NEUTRAL_SENSITIVE: "Build Core Support",
    ROTATIONAL_INTOLERANT: "Reduce Sensitivity to Twisting",
  },
};
